module.exports = __webpack_public_path__ + "static/media/174-portugal.ae6f327c.svg";